import { render, staticRenderFns } from "./dishes.vue?vue&type=template&id=ce8ab106&"
import script from "./dishes.vue?vue&type=script&lang=js&"
export * from "./dishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports